import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const messages = {
  en: require('./locales/en.json'),
  ru: require('./locales/ru.json'),
  lv: require('./locales/lv.json'),
};

const LOCALES = ['en', 'ru', 'lv'];

export const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en',
  silentFallbackWarn: true,
  fallbackLocale: 'en',
  messages,
  postTranslation(value, key) {
    // fallback to displaying key if translation value is empty
    return !value ? key : value;
  },
  pluralizationRules: {
    ru: function (choice, choicesLength) {
      if (choice === 0) {
        return 0;
      }

      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;

      if (choicesLength < 4) {
        return !teen && endsWithOne ? 1 : 2;
      }
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }

      return choicesLength < 4 ? 2 : 3;
    },
  },
});

export default function t(str, params) {
  return i18n.t(str, params) ? i18n.t(str, params) : str;
}

export function changeLocale(lang = 'en') {
  if (LOCALES.includes(lang)) {
    i18n.locale = lang;
    localStorage.setItem('locale', lang);
    document.querySelector('html').setAttribute('lang', lang);
  }
  return lang;
}
